import { observer } from 'mobx-react-lite';
import React, { useRef, useState, useEffect } from 'react';

import PopupsManager from 'react-sdk/PopupsManager';


import classes from './PopupFtue.module.css'
import Button from '@/components/shared/Button/Button';
import { POPUPS } from '@/js/AppState';
import Texts from 'react-sdk/Texts';
import { FaXmark } from 'react-icons/fa6';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const PopupFtue = () => {

  const [datas, setDatas] = useState(null)
  const [pages, setPages] = useState(null)

  const [closeAnimation, setCloseAnimation] = useState(false)

  const [pageIndex, setPageIndex] = useState(-1)

  useEffect(() => {
    setDatas(PopupsManager.getData(POPUPS.FTUE))
  }, [])

  useEffect(() => {
    if (datas) {
      setPages(datas.pages)
    }
  }, [datas])

  useEffect(() => {
    if (pages) {
      setPageIndex(0)
    }
  }, [pages])



  const closeFtue = () => {

    // if (datas.animated && !closeAnimation) {
    setCloseAnimation(true)

    setTimeout(() => {
      PopupsManager.close(POPUPS.FTUE)
    }, 1000)
    // }
    // else if (!datas.animated) {
    //   PopupsManager.close(POPUPS.FTUE)
    // }

  }

  const pageDone = () => {

    if (pageIndex === pages.length - 1) {
      closeFtue()
    }
    else {
      setPageIndex(pi => pi + 1)
    }
  }

  return (
    <div className={classes.PopupFtue}>
      <div className={classes.bg} onClick={() => closeFtue()} />
      {(pages && pageIndex !== -1) &&
        <div className={`${classes.popup} ${(closeAnimation ? classes.closing : '')}`}>
          <div className={classes.content}>
            <div className={classes.rules}>
              {`${Texts.get("popup-ftue-pages")} ${pageIndex + 1} / ${pages.length}`}
            </div>
            <div className={classes.title}>
              {pages[pageIndex].title}
            </div>
            <div className={classes.image}>
              {/* <FullScreen onClick={ () => PopupsManager.open(POPUPS.IMAGE, datas[pageIndex].image) }></FullScreen> */}
              <img src={pages[pageIndex].image} />
            </div>



            <div className={classes.description}>{pages[pageIndex].description}</div>
            {!pages[pageIndex].done && <Button className={classes.doneBtn} onClick={() => pageDone()}>{Texts.get("popup-ftue-close-button")}</Button>}
            {
              pages[pageIndex].done && pages.length > 1 && <div className={classes.nav_buttons}>
                {<Button disabled={pageIndex === 0} icon={<FaChevronLeft />} className={classes.closeBtn} onClick={() => setPageIndex(pi => pi - 1)} />}
                {<Button disabled={pageIndex === pages.length - 1} icon={<FaChevronRight />} className={classes.closeBtn} onClick={() => setPageIndex(pi => pi + 1)} />}
              </div>
            }
          </div>
          {pages[pageIndex].done &&
            <Button className={classes.closeButton} onClick={() => closeFtue()} icon={<FaXmark />}></Button>}
        </div>}
    </div>
  );
};


const Arrow = ({ reverse }) => {

  return (
    <div className={`${classes.Arrow} ${reverse ? classes.reverse : ''}`}>
      <svg width="21" height="36" viewBox="0 0 21 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M20.165 19.9997L4.03244 36L0 32.0006L14.1164 18L0 3.99937L4.03244 0L20.165 16.0003C20.6997 16.5307 21 17.25 21 18C21 18.75 20.6997 19.4693 20.165 19.9997Z" fill="#0F293B" />
      </svg>
    </div>
  )

}

const FullScreen = ({ onClick }) => {

  const handleClick = () => {
    if (onClick) onClick()
  }

  return (
    <div className={classes.FullScreen} onClick={() => handleClick()}>
      <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 37V26.7222H4.11111V32.8889H10.2778V37H0ZM26.7222 37V32.8889H32.8889V26.7222H37V37H26.7222ZM0 10.2778V0H10.2778V4.11111H4.11111V10.2778H0ZM32.8889 10.2778V4.11111H26.7222V0H37V10.2778H32.8889Z" fill="white" />
      </svg>
    </div>
  )
}


export default observer(PopupFtue)
